export default function serverCode(name, args, locale) {
  if (!args) args = {}
  args.locale = locale
  const entry = Kii.serverCodeEntry(name)
  return entry.execute(args).then(params => {
    const { returnedValue } = params[2].getReturnedValue()
    console.log(name, args, returnedValue)
    return returnedValue
  })
}
